/*
 * jQuery must not be used here
 */

(function () {
  'use strict';

  /**
   * Prepare datalayer if not present
   */
  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = [];
  }

  /**
   * Custom dispatch event function
   *
   * @param element
   * @param event
   * @param type
   * @param bubbles
   * @param cancelable
   * @param detail
   * @returns {boolean}
   */
  window.dispatchEventType = function (
    element,
    event,
    type,
    bubbles,
    cancelable,
    detail
  ) {
    bubbles = 'undefined' === typeof bubbles ? false : !!bubbles;
    cancelable = 'undefined' === typeof cancelable ? false : !!cancelable;
    type = 'undefined' === typeof type ? 'HTMLEvents' : type;
    detail = 'undefined' === typeof detail ? {} : detail;

    if (!element.dispatchEvent) {
      return false;
    }

    var e;

    if ('undefined' !== typeof document.createEvent) {
      e = document.createEvent(type);
      if ('undefined' !== typeof e.initCustomEvent) {
        e.initCustomEvent(event, bubbles, cancelable, detail);
      } else {
        e = null;
      }
    }

    if (!e && 'undefined' !== typeof CustomEvent) {
      switch (type) {
        case 'MouseEvents':
          e = new MouseEvent(event, {
            bubbles: bubbles,
            cancelable: cancelable,
            detail: detail,
          });
          break;
        case 'UIEvents':
          e = new UIEvent(event, {
            bubbles: bubbles,
            cancelable: cancelable,
            detail: detail,
          });
          break;
        default:
          e = new CustomEvent(event, {
            bubbles: bubbles,
            cancelable: cancelable,
            detail: detail,
          });
      }
    }

    if (e) {
      element.dispatchEvent(e);
    }
  };

  /**
   * Google API callbacks
   */
  window.placesApiLoaded = function () {
    document.placesApiLoaded = true;
    document.mapsApiLoaded = true;
    dispatchEventType(document, 'placesApiLoaded');
    dispatchEventType(document, 'mapsApiLoaded');
  };

  window.mapsApiLoaded = function () {
    document.mapsApiLoaded = true;
    dispatchEventType(document, 'mapsApiLoaded');
  };

  window.recaptchaLoaded = function () {
    document.recaptchaLoaded = true;
    dispatchEventType(document, 'recaptchaLoaded');
  };

  window.onYouTubeIframeAPIReady = function () {
    document.youTubeIframeApiLoaded = true;
    dispatchEventType(document, 'youTubeIframeApiLoaded');
  };
})();
